export default function (item) {
  const variant = item.product.variants.find(v => v.size === item.variant.size)
  return variant.packing_price || 0
}
